import React from 'react';
import { MONO, SANS } from '../../constants/fonts';

function PageHero({ eyebrow, headline, image, imageAlt = '', sub, badge }) {
  return (
    <section style={s.hero}>
      <p style={s.eyebrow}>{eyebrow}</p>
      <h1 style={s.headline}>{headline}</h1>
      <div style={s.imageWrapper}>
        <img src={image} alt={imageAlt} style={s.image} />
      </div>
      <p style={s.sub}>{sub}</p>
      <div style={s.badgeWrapper}>{badge}</div>
    </section>
  );
}

const s = {
  hero: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: 'clamp(36px, 7vw, 80px) 24px clamp(20px, 3vw, 36px)',
    borderBottom: '1px solid #ebebeb',
    fontFamily: SANS,
  },
  eyebrow: {
    fontFamily: MONO,
    fontSize: '0.78rem',
    fontWeight: 500,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: '#9ca3af',
    margin: '0 0 22px',
  },
  headline: {
    fontSize: 'clamp(2.2rem, 7vw, 4.2rem)',
    fontWeight: 800,
    letterSpacing: '-0.03em',
    lineHeight: 1.1,
    color: '#1c1c1e',
    margin: 0,
  },
  imageWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'clamp(260px, 36vw, 360px)',
    height: 'clamp(174px, 24vw, 240px)',
    marginTop: 0,
    marginBottom: 16,
  },
  image: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    width: 'auto',
    height: 'auto',
    borderRadius: 20,
    mixBlendMode: 'multiply',
  },
  sub: {
    fontSize: 'clamp(0.88rem, 2vw, 1.05rem)',
    color: '#6b6b6b',
    lineHeight: 1.7,
    maxWidth: 520,
    margin: '0 0 28px',
    minHeight: '5.1em',
  },
  badgeWrapper: {
    minHeight: 48,
    display: 'flex',
    alignItems: 'center',
  },
};

export default PageHero;
